import PrivacyPolicy from "./components/privacy-policy/privacy-policy";
import PageWrapper from "../wrappers/page-wrapper";

PrivacyPolicy.domainName = "privacy-policy";

export default PageWrapper(PrivacyPolicy);
